import { Card, Text, Group, Anchor } from '@mantine/core';
import { useNavigate, useLocation } from "react-router-dom";
import { modals } from '@mantine/modals';
import CampaignApi from "../../api/CampaignApi";

export function MultipleUserLogin({ ipaddress }:any) {

  const location = useLocation();
  const navigate = useNavigate();
  const ipAddress = location.state?.ip_address;
  const type = location.state?.type;
  const id = location.state?.id;
  const test_type = location.state?.test_type;
  const taguchi_id = location.state?.taguchi_id;

  const handlebackButton = () => {
    if(type === 'campaign'){
      navigate("/manage-campaigns");
    }else if(type === 'test'){
      navigate("/review-tests");
    }else if(type === 'create-test'){
      navigate("/create-test");
    }
  }

  const handleGetPrimaryAccess = () => modals.openConfirmModal({
    trapFocus: false,
    title: 'Please confirm your action',
    children: (
      <>
      <Text size="sm">
        Do you wish to proceed? Proceeding will give you primary access but the other user will be forced out and may lose changes that they have made.
      </Text>
      </>
    ),
    labels: { confirm: 'Confirm', cancel: 'Cancel' },
    onCancel: () => {},
    onConfirm: () => {handleDeleteIpAddress()} 
  });

  const handleDeleteIpAddress = () => {
    CampaignApi.deletemultipleloginipaddress({
      table_id : id,
      ip_address: ipAddress,
      type: type === 'campaign' ? 'campaign-setup' : 'test-setup'
    })
    .then(response => {
      if (response.ok) {
        return response.json();
      } else {
        if (response.status === 401 || response.status === 400) {
          navigate("/logout");
        }
      }
    })
    .then(data => {
      if(data.status === 1){
        if(type === 'campaign'){
          navigate(`/create-campaign/${id}`);
        }else if(type === 'test'){
          if(test_type === 'modern_test'){
            const url = `/test-editor-visual-modern/${id}/${taguchi_id}`;
            window.open(url, '_self');
          }else{
            const url = `/test-editor-visual/${id}/${taguchi_id}`;
            window.open(url, '_self');
          }
        }else if(type === 'create-test'){
          navigate("/create-test");
        }
      }
    })
    .catch(error => {
      console.log(error);      
    });
  }

  return (
    <div style={{ display: 'flex', justifyContent: 'center', marginTop: '50px', background: '#f5f5f5' }}>
      <Card shadow="sm" padding="lg" radius="md" withBorder style={{ maxWidth: 700, textAlign: 'center' }}>
        <Text size="lg" weight={700} color="red">WARNING</Text>
        <Text mt="md">
          Another user is already logged into this account. <Text span weight={700} color="red">IP: {ipAddress}</Text>
        </Text>
        {type === 'campaign' && (
          <>
            <Text mt="md">
              If they have begun to set up a campaign on the page you selected, you will not be able to make any changes until their session is complete, or they log out.
            </Text>
            <Text mt="md">
              You can view campaigns but proceed with caution to avoid errors.
            </Text>
          </>
        )}
        {(type === 'test' || type === 'create-test') && (
          <>
            <Text mt="md">
              If they have begun to set up a test on the page you selected, you will not be able to make any changes until their session is complete, or they log out.
            </Text>
            <Text mt="md">
              You can view reports but proceed with caution to avoid errors.
            </Text>
          </>
        )}

        <Group position="center" mt="xl">
          <Anchor color="blue" component="button" type="button" onClick={handlebackButton}>Go Back!</Anchor>
          <Anchor color="red" component="button" type="button" onClick={handleGetPrimaryAccess}>Gain Primary Access</Anchor>
        </Group>
      </Card>
    </div>
  );
} 
